import React, { HTMLProps, RefObject, useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { Color } from '../utils/constants'

interface ScrollBarProps extends HTMLProps<HTMLDivElement> {
  scrollRef: RefObject<HTMLDivElement>
  isVertical?: boolean
  color?: Color
}

const ScrollBar = ({
    scrollRef,
    isVertical = true,
    color = Color.BLACK,
    style,
    ...props
}: ScrollBarProps) => {
    const [fillPercentage, setFillPercentage] = useState(0)
    useEffect(() => {
        const scrollHandler = () => {
            requestAnimationFrame(() => {
                if (scrollRef.current) {
                    const { scrollHeight, scrollWidth, scrollTop, scrollLeft, clientHeight, clientWidth } =
            scrollRef.current
                    const full = isVertical ? scrollHeight : scrollWidth
                    const current = isVertical ? scrollTop + clientHeight : scrollLeft + clientWidth
                    setFillPercentage(current / full)
                }
            })
        }
        scrollHandler()
    scrollRef.current?.addEventListener('scroll', scrollHandler)
    if (scrollRef.current) {
        const config = { attributes: true, childList: true, subtree: true }
        const observer = new MutationObserver((_, obs) => {
            scrollHandler()
            obs.disconnect()
        })
        observer.observe(scrollRef.current, config)
        // observer.disconnect();
    }
    }, [scrollRef.current])

    if (isVertical && scrollRef.current?.clientHeight === scrollRef.current?.scrollHeight) {
        return <></>
    }

    const getColor = () => {
        switch (color) {
        case Color.WHITE:
            return 'bg-white/10'
        case Color.BLACK:
        default:
            return 'bg-black/10'
        }
    }
    return (
        <div
            {...props}
            style={style}
            className={twMerge('rounded-full', getColor(), isVertical ? 'w-1' : 'h-1')}
        >
            <div
                className={twMerge('rounded-full ', isVertical ? 'w-full' : 'h-full')}
                style={{
                    backgroundColor: color,
                    height: isVertical ? `${fillPercentage * 100}%` : undefined,
                    width: !isVertical ? `${fillPercentage * 100}%` : undefined,
                }}
            />
        </div>
    )
}

export default ScrollBar
